/**
 * @file This file defined for get url parameters
 * @author Bhanuka Chathuranga
 */
import { useLocation } from "react-router-dom";

export default function useQuery() {
    return new URLSearchParams(useLocation().search);
  }